export default "__VITE_ASSET__78951585__"